import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Sync as ChangeIcon } from '@mui/icons-material';
import { useI18nContext } from '@/i18n/i18n-react';

interface DeleteWindowExpiredDialogProps {
    open: boolean;
    onClose: () => void;
    onRequestReplacement: () => void;
}

/**
 * Shown when a regular user tries to delete their own assignment after the
 * 5-minute self-delete window has expired.  Explains the rule and offers a
 * "Request Replacement" shortcut that immediately creates a change request.
 */
const DeleteWindowExpiredDialog = ({
    open: propOpen,
    onClose,
    onRequestReplacement,
}: DeleteWindowExpiredDialogProps) => {
    const { LL } = useI18nContext();

    const handleRequestReplacement = () => {
        onClose();
        onRequestReplacement();
    };

    return (
        <Dialog
            open={propOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="delete-window-expired-title"
        >
            <DialogTitle id="delete-window-expired-title">
                {LL.categoryItem.deleteWindowExpiredTitle()}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {LL.categoryItem.deleteWindowExpiredMessage()}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{LL.common.cancel()}</Button>
                <Button
                    variant="contained"
                    color="warning"
                    startIcon={<ChangeIcon fontSize="small" />}
                    onClick={handleRequestReplacement}
                >
                    {LL.categoryItem.requestReplacement()}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteWindowExpiredDialog;
